import React from "react";

class ReadClaimFunction extends React.Component {
  state = { dataKey: null };

  componentDidMount() {
    const { drizzle, drizzleState } = this.props;
    const contract = drizzle.contracts.ClaimPriorityDate;
    // let drizzle know we want to watch the `weiPerSpx` method	

	var dataKey
	
	if (typeof this.props.dictkey === 'undefined') {
		dataKey = contract.methods[this.props.value].cacheCall();
	} else {
		dataKey = contract.methods[this.props.value].cacheCall(this.props.dictkey);
		
	}
		
	this.setState({ dataKey });


    // save the `dataKey` to local component state for later reference
    
	
	
	// Inject Initalization of SPXToken Here
	
	
  }

  render() {
    // get the contract state from drizzleState
    const { ClaimPriorityDate } = this.props.drizzleState.contracts;
    // using the saved `dataKey`, get the variable we're interested in
	const myfunctionvalue = ClaimPriorityDate[this.props.value][this.state.dataKey]
    // if it exists, then we display its value
    return (
	<> {myfunctionvalue && myfunctionvalue.value}. </>);
  }
}

export default ReadClaimFunction;